import { render, staticRenderFns } from "./permission-manage.vue?vue&type=template&id=3b2fa408&scoped=true"
import script from "./permission-manage.vue?vue&type=script&lang=js"
export * from "./permission-manage.vue?vue&type=script&lang=js"
import style0 from "./permission-manage.vue?vue&type=style&index=0&id=3b2fa408&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2fa408",
  null
  
)

export default component.exports